import { dwCollect } from '@/utils/dw-collect';
import { RespApp } from '@vas2t-lowcode/api';
import { usePTeamStore } from '@/store';

const getAppidName = (appData: RespApp) => {
  const appid = appData.third_app_id;
  const app_name = appData.name;

  return { appid, app_name };
};

/**
 * 我的应用展示
 */
export const dwMyAppShow = () => {
  const module = usePTeamStore().isShowAllAppDialog ? 'all_app' : 'app';
  dwCollect({ module, action: 'show' });
};

/**
 * dw hover 应用
 *
 * @param appid
 * @param app_name
 */
export const dwOnAppHover = (appData: RespApp) => {
  const module = usePTeamStore().isShowAllAppDialog ? 'all_app' : 'app';
  const from = appData.tpl_id || 'custom';
  const key2 = appData.tpl_name || '空白';
  const comp_id = appData.third_ws_id;
  dwCollect({ module, element: 'app', action: 'hover', from, key2, ...getAppidName(appData), comp_id });
};

/**
 * dw click 应用
 *
 * @param appid
 * @param app_name
 */
export const dwOnAppClick = (appData: RespApp) => {
  const module = usePTeamStore().isShowAllAppDialog ? 'all_app' : 'app';
  const from = appData.tpl_id || 'custom';
  const key2 = appData.tpl_name || '空白';
  const comp_id = appData.third_ws_id;
  dwCollect({ module, element: 'app', action: 'click', from, key2, ...getAppidName(appData), comp_id });
};

/**
 * dw click 删除应用
 *
 * @param {type: RespApp}  appData
 */
export const dwOnDelAppClick = (appData: RespApp) => {
  const module = usePTeamStore().isShowAllAppDialog ? 'all_app' : 'app';
  const from = appData.tpl_id || 'custom';
  const key2 = appData.tpl_name || '空白';
  const comp_id = appData.third_ws_id;
  dwCollect({ module, element: 'delete', action: 'click', from, key2, ...getAppidName(appData), comp_id });
};

/**
 * dw 删除应用成功
 *
 * @param {type: RespApp}  appData
 */
export const dwOnDelAppSuccess = (appData: RespApp) => {
  const module = usePTeamStore().isShowAllAppDialog ? 'all_app' : 'app';
  const from = appData.tpl_id || 'custom';
  const key2 = appData.tpl_name || '空白';
  const comp_id = appData.third_ws_id;
  dwCollect({ module, element: 'delete', action: 'success', from, key2, ...getAppidName(appData), comp_id });
};

/**
 * dw 点击【购买】应用
 *
 * @param {type: RespApp}  appData
 */
export const dwOnBuyAppClick = (appData: RespApp) => {
  const module = usePTeamStore().isShowAllAppDialog ? 'all_app' : 'app';
  const from = appData.tpl_id || 'custom';
  const key2 = appData.tpl_name || '空白';
  const comp_id = appData.third_ws_id;
  dwCollect({ module, element: 'buy', action: 'click', from, key2, ...getAppidName(appData), comp_id });
};

/**
 * dw 点击【续费】应用
 *
 * @param {type: RespApp}  appData
 */
export const dwOnRenewAppClick = (appData: RespApp) => {
  const module = usePTeamStore().isShowAllAppDialog ? 'all_app' : 'app';
  const from = appData.tpl_id || 'custom';
  const key2 = appData.tpl_name || '空白';
  const comp_id = appData.third_ws_id;
  dwCollect({ module, element: 'renew', action: 'click', from, key2, ...getAppidName(appData), comp_id });
};

/**
 * 试用到期弹窗展示（针对超管）
 *
 * @param {type: RespApp}  appData
 */
export const dwOnAppTrailTipsDialogShow = (appData: RespApp) => {
  const module = usePTeamStore().isShowAllAppDialog ? 'all_app' : 'app';
  const from = appData.tpl_id || 'custom';
  const key2 = appData.tpl_name || '空白';
  const comp_id = appData.third_ws_id;
  dwCollect({ module, func: 'try', action: 'show', from, key2, ...getAppidName(appData), comp_id });
};

/**
 * 套餐到期弹窗展示（针对超管）
 *
 * @param {type: RespApp}  appData
 */
export const dwOnAppDueTipsDialogShow = (appData: RespApp) => {
  const module = usePTeamStore().isShowAllAppDialog ? 'all_app' : 'app';
  const from = appData.tpl_id || 'custom';
  const key2 = appData.tpl_name || '空白';
  const comp_id = appData.third_ws_id;
  dwCollect({ module, func: 'due', action: 'show', from, key2, ...getAppidName(appData), comp_id });
};

/**
 * 试用到期弹窗-点击【购买】
 *
 * @param {type: RespApp}  appData
 */
export const dwOnAppTipsBuyClick = (appData: RespApp) => {
  const module = usePTeamStore().isShowAllAppDialog ? 'all_app' : 'app';
  const from = appData.tpl_id || 'custom';
  const key2 = appData.tpl_name || '空白';
  const comp_id = appData.third_ws_id;
  dwCollect({ module, func: 'try', element: 'buy', action: 'click', from, key2, ...getAppidName(appData), comp_id });
};

/**
 * 套餐到期弹窗-点击【购买】
 *
 * @param {type: RespApp}  appData
 */
export const dwOnAppTipsDueBuyClick = (appData: RespApp) => {
  const module = usePTeamStore().isShowAllAppDialog ? 'all_app' : 'app';
  const from = appData.tpl_id || 'custom';
  const key2 = appData.tpl_name || '空白';
  const comp_id = appData.third_ws_id;
  dwCollect({ module, func: 'due', element: 'buy', action: 'click', from, key2, ...getAppidName(appData), comp_id });
};

/**
 * 付费方案弹窗展示
 *
 * @param {type: RespApp}  appData
 */
export const dwOnAppPayDialogShow = (appData: RespApp) => {
  const module = usePTeamStore().isShowAllAppDialog ? 'all_app' : 'app';
  const from = appData.tpl_id || 'custom';
  const key2 = appData.tpl_name || '空白';
  const comp_id = appData.third_ws_id;
  dwCollect({ module, func: 'pay', action: 'show', from, key2, ...getAppidName(appData), comp_id });
};

/**
 * 付费方案弹窗-【点击购买平台】
 *
 * @param {type: RespApp}  appData
 */
export const dwOnAppPayPlatClick = (appData: RespApp) => {
  const module = usePTeamStore().isShowAllAppDialog ? 'all_app' : 'app';
  const from = appData.tpl_id || 'custom';
  const key2 = appData.tpl_name || '空白';
  const comp_id = appData.third_ws_id;
  dwCollect({
    module,
    func: 'pay',
    element: 'buy',
    action: 'click',
    from,
    key1: 'plat',
    key2,
    ...getAppidName(appData),
    comp_id,
  });
};

/**
 * 付费方案弹窗-【点击购买应用】
 *
 * @param {type: RespApp}  appData
 */
export const dwOnAppPayAppClick = (appData: RespApp) => {
  const module = usePTeamStore().isShowAllAppDialog ? 'all_app' : 'app';
  const from = appData.tpl_id || 'custom';
  const key2 = appData.tpl_name || '空白';
  const comp_id = appData.third_ws_id;
  dwCollect({
    module,
    func: 'pay',
    element: 'buy',
    action: 'click',
    from,
    key1: 'app',
    key2,
    ...getAppidName(appData),
    comp_id,
  });
};

/**
 * 点击【展开】
 *
 */
export const dwOnAppMoreClick = () => {
  const module = usePTeamStore().isShowAllAppDialog ? 'all_app' : 'app';
  dwCollect({ module, element: 'more', action: 'click' });
};

/**
 * 增加人数 | 续费平台
 */
export const dwAppPayUpOrRenew = (appData: RespApp, element: 'upgrade_member' | 'renew_plat') => {
  const from = appData.tpl_id || 'custom';
  const key2 = appData.tpl_name || '空白';
  const module = usePTeamStore().isShowAllAppDialog ? 'all_app' : 'app';
  const comp_id = appData.third_ws_id;
  dwCollect({ module, action: 'click', element, from, key2, ...getAppidName(appData), comp_id });
};

/**
 * 单个应用展示
 */

export const dwMyAppSingleShow = (appData: RespApp) => {
  const from = appData.tpl_id || 'custom';
  const key2 = appData.tpl_name || '空白';
  const module = usePTeamStore().isShowAllAppDialog ? 'all_app' : 'app';
  const comp_id = appData.third_ws_id;
  dwCollect({ module, func: 'app', action: 'show', from, key2, ...getAppidName(appData), comp_id });
};
